export const PAYMENT_STATUS = {
  PAID: 'paid',
};

export const PAYMENT_TYPE = {
  AUTO: 'auto',
  MANUAL: 'manual',
};

export const PRE_APPT_STEPS = [
  { key: 'appointment', title: 'Appointment' },
  { key: 'payment', title: 'Payment' },
];

// Shown before the step counter, as booking shows "New booking · 1 of 4".
export const PRE_APPT_COUNTER_PREFIX = 'Appointment payment';

export const PRE_APPT_STEP_NUMBER = {
  APPOINTMENT: 1,
  PAYMENT: 2,
  COMPLETE: 3,
};
